module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var snapNumbers = [1,2,5,10,100];

    ; __append("\r\n\r\n<div class=\"propTitle prop-header hide\"><span class=\"prop-label\">Slider Settings</span></div>\r\n<div class=\"main-slider prop-detail\" >\r\n\r\n        <div class=\"row\" style='")
    ; __append(escapeFn( mobileDesignerStyle ))
    ; __append("'>\r\n            <div class=\"col-md-6 subsection nopadding-r\">\r\n                <label class=\"prop-sublabel label-35\">Min</label> \r\n                <div>\r\n                    <input type=\"text\" id=\"mainSliderMin\" value=\"")
    ; __append(escapeFn(minValue))
    ; __append("\" name=\"minValue\" class=\"label-45\"/>\r\n                </div>\r\n            </div>\r\n            \r\n            <div class=\"col-md-6 subsection nopadding-r\">\r\n                <label class=\"prop-sublabel label-35\">Max</label> \r\n                <div>\r\n                    <input type=\"text\" id=\"mainSliderMax\" value=\"")
    ; __append(escapeFn(maxValue))
    ; __append("\" name=\"maxValue\" class=\"label-45\"/>\r\n                </div>\r\n            </div>\r\n            \r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-6 subsection nopadding-r\" style='")
    ; __append(escapeFn( mobileDesignerStyle ))
    ; __append("'>\r\n                <label class=\"prop-sublabel label-35\">Snap</label> \r\n                <div>\r\n                    <select name=\"snapInterval\" id=\"mainSliderSnap\" class=\"label-45\">\r\n                        ")
    ;  for (var i = 0; i < snapNumbers.length; i++) { 
    ; __append("\r\n                            <option value=\"")
    ; __append(escapeFn(snapNumbers[i]))
    ; __append("\">")
    ; __append(escapeFn(snapNumbers[i]))
    ; __append("</option>\r\n                        ")
    ;  }; 
    ; __append("\r\n                    </select>\r\n                </div>\r\n            </div>\r\n            \r\n            <div class=\"col-md-6 nopadding-r\" style=\"display: inline-flex;\">\r\n                <input id=\"sliderColorPicker\" type=\"color\" name=\"colorPicker\" value=\"")
    ; __append(escapeFn( sliderColor ))
    ; __append("\" />\r\n                <input id=\"sliderColor\" type=\"text\" maxlength=\"7\" name=\"sliderColor\" value=\"")
    ; __append(escapeFn( sliderColor ))
    ; __append("\" style=\"width: 55px; float:left;\" />\r\n            </div>\r\n        </div>\r\n</div>")
  }
  return __output;

}